// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkDownloadPing-cls1_6uL","cls2":"BulkDownloadPing-cls2_BxC BulkDownloadPing-cls1_6uL"};